import {
  promoImageMap,
  headerTextMap,
  promoHeadingTextClassMap,
} from 'site-modules/appraisal/constants/appraisal-promotions';

/**
 * @typedef {Object} PromoImages
 * @property {string} DESKTOP The URL for the desktop version of the promotion image.
 * @property {string} MOBILE The URL for the mobile version of the promotion image.
 */

/**
 * Retrieves the desktop and mobile image URLs for a given promotion.
 * @param {string|undefined} promo The name of the promotion.
 * @returns {PromoImages} An object `{DESKTOP, MOBILE}` containing the desktop and mobile image URLs.
 */

export const getAppraisalPromotionsBackground = promo => {
  const { DESKTOP, MOBILE } = promoImageMap[promo] || promoImageMap.default;
  return { DESKTOP, MOBILE };
};

/**
 * Retrieves the header and subheader texts for a given promotion.
 * @param {string|undefined} promo The name of the promotion.
 * @returns {{ HEADER: string, SUBHEADER: string }} An object `{HEADER, SUBHEADER}` containing the header and subheader texts.
 */
export const getAppraisalPromotionsHeaderText = promo => {
  const { HEADER, SUBHEADER } = headerTextMap[promo] || headerTextMap.default;
  return { HEADER, SUBHEADER };
};

/**
 * Retrieves the heading text shadow class for a given promotion.
 * @param {string|undefined} promo The name of the promotion.
 * @returns {string} A class name for promo heading styling.
 */
export const getAppraisalPromotionsHeadingTextClass = promo =>
  promoHeadingTextClassMap[promo] || promoHeadingTextClassMap.default;
